import { Box, CircularProgress, makeStyles } from '@material-ui/core'
import React from 'react'
import { useQuery } from 'react-query'

import Api from 'api'
import { useLanguageContext } from 'components/LanguageContext'
import parseHtml from 'components/parseHtml'
import SimpleDialog from '../SimpleDialog'

const useStyles = makeStyles(theme => ({
  contentRoot: {
    [theme.breakpoints.down('xs')]: {
      padding: 10,
    },
    '& p:first-of-type': {
      fontWeight: 'bold',
      marginTop: 0,
    },
  },
  loadingContainer: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}))

export default React.forwardRef(function CategoryDialog({}, ref) {
  const { isSpanish, language } = useLanguageContext()
  const dialogRef = React.useRef()

  const [category, setCategory] = React.useState(null)

  const { isLoading: isLoadingPages, data: pagesData } = useQuery({
    queryKey: ['pages', category?.guide],
    queryFn: () => Api.getPages({ slug: category?.guide }),
    enabled: !!category,
  })

  const { isLoading: isLoadingCategories, data: categoriesData } = useQuery({
    queryKey: ['categories'],
    queryFn: Api.getCategories,
  })

  const onCloseRef = React.useRef()

  const open = React.useCallback((category, onClose) => {
    if (!category) {
      return
    }

    setCategory(category)
    onCloseRef.current = onClose

    dialogRef.current.open()
  }, [])

  const handleClose = React.useCallback(() => {
    dialogRef.current.close()
    onCloseRef.current?.()
    onCloseRef.current = undefined
  }, [])

  React.useImperativeHandle(ref, () => ({
    open,
  }))

  const classes = useStyles()

  const categoryInfo = categoriesData?.categories.find(
    x => x.id === category?.id
  )
  const guides = pagesData?.pages

  const renderContent = React.useCallback(() => {
    if (isLoadingPages || isLoadingCategories) {
      return (
        <Box className={classes.loadingContainer}>
          <CircularProgress />
        </Box>
      )
    }

    if (!categoryInfo) {
      return
    }

    const guide = guides?.find(x => x.language === language)

    return (
      <Box className={classes.contentRoot}>
        {guide ? parseHtml(guide.content) : null}
      </Box>
    )
  }, [isLoadingPages, isLoadingCategories, categoryInfo, language, classes, guides])

  const title = categoryInfo
    ? isSpanish
      ? categoryInfo.name_es
      : categoryInfo.name
    : null

  return (
    <SimpleDialog ref={dialogRef} title={title} onClose={handleClose}>
      {renderContent()}
    </SimpleDialog>
  )
})
